var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestmentPortfolioFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#00205A",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7751 22.7645L10.6851 22.6745C10.2951 22.2845 10.2951 21.6545 10.6851 21.2645L16.7751 15.1645C17.1651 14.7745 17.7951 14.7745 18.1851 15.1645L21.4751 18.4545L27.8651 11.2745C28.2451 10.8445 28.9151 10.8345 29.3151 11.2345C29.6851 11.6145 29.7051 12.2145 29.3551 12.6045L22.1851 20.6745C21.8051 21.1045 21.1451 21.1245 20.7351 20.7145L17.4851 17.4645L12.1851 22.7645C11.8051 23.1545 11.1651 23.1545 10.7751 22.7645ZM12.1851 28.7645L17.4851 23.4645L20.7351 26.7145C21.1451 27.1245 21.8051 27.1045 22.1851 26.6745L29.3551 18.6045C29.7051 18.2145 29.6851 17.6145 29.3151 17.2345C28.9151 16.8345 28.2451 16.8445 27.8651 17.2745L21.4751 24.4545L18.1851 21.1645C17.7951 20.7745 17.1651 20.7745 16.7751 21.1645L10.6851 27.2645C10.2951 27.6545 10.2951 28.2845 10.6851 28.6745L10.7751 28.7645C11.1651 29.1545 11.8051 29.1545 12.1851 28.7645Z",
    fill: "#00205A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentPortfolioFilledIcon);
export default __webpack_public_path__ + "static/media/investment_portfolio_filled_icon.46e1f7bf3ab7394e1bec5b0f09fa3af5.svg";
export { ForwardRef as ReactComponent };